import { Actions } from 'vuex-smart-module';
import { PartnerProductsService } from '@/modules/partner-products/services';
import { ResponseStatuses } from '@/enums';
import { PartnerProducts } from '@/modules/partner-products/types';
import PartnerProductsGetters from './getters';
import PartnerProductsMutations from './mutations';
import PartnerProductsState from './state';

const service = new PartnerProductsService();

export default class PartnerProductsActions extends Actions<
  PartnerProductsState,
  PartnerProductsGetters,
  PartnerProductsMutations,
  // eslint-disable-next-line no-use-before-define
  PartnerProductsActions
> {
  async get_partner_products() {
    try {
      const {
        sortBy = [], sortDesc = [], page = 1, itemsPerPage = 10,
      } = this.state.table_options;

      const payload: PartnerProducts.Request = {
        filters: this.state.filters,
        filters_exist: true,
        pagination: {
          limit: itemsPerPage,
          page,
          sort: '',
          sort_type: 'asc',
        },
      };

      if (sortBy?.length) {
        [payload.pagination.sort] = sortBy;
      }

      if (sortDesc?.length) {
        payload.pagination.sort_type = sortDesc[0] ? 'desc' : 'asc';
      }

      this.mutations.TOGGLE_LOADING_PARTNER_PRODUCTS(true);

      const { data, meta } = await service.get_partner_products(payload);

      this.mutations.UPD_TABLE_OPTIONS({ key: 'page', value: meta.current_page });
      this.mutations.UPD_TABLE_OPTIONS({ key: 'itemsPerPage', value: meta.limit });
      this.mutations.UPD_PAGINATION_PRODUCTS_FIELD({ key: 'current_page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_PRODUCTS_FIELD({ key: 'total_pages', value: meta.total_pages });
      this.mutations.UPD_PAGINATION_PRODUCTS_FIELD({ key: 'total_items', value: meta.total_items });
      this.mutations.UPD_PAGINATION_PRODUCTS_FIELD({ key: 'limit', value: meta.limit });

      this.mutations.SET_PARTNER_PRODUCTS(data.items);
    } catch (error) {
      console.error(error);
    } finally {
      this.mutations.TOGGLE_LOADING_PARTNER_PRODUCTS(false);
    }
  }

  async create_partner_products() {
    const payload = {
      ...this.state.new_partner_product,
    };

    const form_data = new FormData();

    Object.keys(payload).forEach((key) => {
      if (payload[key] === null) return;

      if (!Array.isArray(payload[key])) {
        form_data.append(key, payload[key] as string | Blob);
      }
    });

    const data = await service.create_partner_products(form_data);

    if (data.data.id) {
      this.mutations.ADD_NEW_PARTNER_PRODUCT(data.data);
    }

    return !!data.data.id;
  }
}
